import type { RouteRecordRaw } from 'vue-router'

const branchRoutes: RouteRecordRaw[] = [
  {
    path: '',
    component: () => import('@/pages/branch/page-list.vue'),
    name: 'branch list',
    meta: { title: 'List Tim' },
  },
]

export default branchRoutes
